<template>
  <div class="el-col-24">
    <h5 class="warp-title">{{id ? '编辑' : '新增'}}客服工单</h5>
    <div class="talkForm">
      <el-form :model="talkForm" size="small" :rules="talkRule" ref="talkForm" class="my-form-style" label-position="left" label-width="auto" style="padding-left: 20px;">
        <el-form-item label="平台" prop="platformType">
          <el-select v-model="talkForm.platformType" placeholder="选择平台" @change="platformTypeChange">
            <el-option :label="item.name" :value="item.id" v-for="(item, index) in platformList" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户类型" prop="platformUserType">
          <el-select v-model="talkForm.platformUserType" placeholder="选择用户类型">
            <el-option v-for="(item, index) in userTypeOption" :key="index" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="组别">
          <el-input v-model.trim="talkForm.groupName" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="处理状态" prop="handerStatus">
          <el-select v-model="talkForm.handerStatus" placeholder="选择处理状态">
            <el-option v-for="(item, index) in statusOption" :key="index" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="平台终端类型">
          <el-select v-model="talkForm.platformTerminalType" placeholder="选择平台终端类型">
            <el-option v-for="(item, index) in terminalTypeOption" :key="index" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户ID" prop="imUserId">
          <el-input v-model.trim="talkForm.imUserId" maxlength="32"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="platformPhone">
          <el-input v-model.trim="talkForm.platformPhone" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="用户信息备注">
          <el-input v-model.trim="talkForm.userRemark" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="受理方式" prop="acceptanceMethod">
          <el-select v-model="talkForm.acceptanceMethod" placeholder="选择受理方式">
            <el-option v-for="(item, index) in methodOption" :key="index" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备信息/课堂信息">
          <el-input v-model.trim="talkForm.equipmentClassInfo" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="问题进展">
          <el-input v-model.trim="talkForm.problemProgress" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="问题分类" prop="problemOneType">
          <div class="flex-common-style">
            <el-select v-model="talkForm.problemOneType" placeholder="问题一级分类" @change="OneTypeChange" clearable style="width: 200px;margin-right: 10px;">
              <el-option v-for="(item, index) in oneTypeOption" :key="index" :label="item.name" :value="item.code"></el-option>
            </el-select>
            <el-select v-model="talkForm.problemTwoType" placeholder="问题二级分类" clearable style="width: 200px">
              <el-option v-for="(item, index) in twoTypeOption" :key="index" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </div>
        </el-form-item>
        <div class="clear"></div>
        <el-form-item label="问题描述" prop="problemDescription">
          <myQuill :content="talkForm.problemDescription" @getQuillContent="getQuillContent" />
        </el-form-item>
        <el-form-item>
          <el-button class="mt_20" type="primary" @click="submitForm">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {addCustomerWorkOrder, editCustomerWorkOrder, queryManyTypeList, queryBusinessTypeList, queryCustomerWorkOrderDetail} from '../../api/order/index'
import rule from '../../api/public/rule'
export default {
  name: 'OrderAddTalk',
  created () {
    // 打印是否登录
    console.log(this.$store.state.Auth.sign)
  },
  computed: {
    platformList () {
      return this.$store.state.Auth.platformList
    }
  },
  data () {
    return {
      id: this.$route.query.id,
      dialogVisible: false,
      videoName: '',
      videoUrl: '',
      playUrl: '',
      linePlaceholder: '',
      talkForm: {
        platformType: '',
        platformUserType: '',
        handerStatus: '',
        imUserId: '',
        platformPhone: '',
        userRemark: '',
        groupName: '',
        problemProgress: '',
        acceptanceMethod: '',
        equipmentClassInfo: '',
        problemOneType: '',
        problemTwoType: '',
        problemDescription: '',
        platformTerminalType: ''
      },
      talkRule: {
        platformType: [
          { required: true, message: '请选择平台', trigger: 'change' }
        ],
        platformUserType: [
          { required: true, message: '请选择用户类型', trigger: 'change' }
        ],
        handerStatus: [
          { required: true, message: '请选择处理状态', trigger: 'change' }
        ],
        // platformTerminalType: [
        //   { required: true, message: '请选择平台终端类型', trigger: 'change' }
        // ],
        imUserId: [
          // { required: true, message: '请输入用户ID', trigger: 'blur' },
          {pattern: rule.num, message: '只可以输入数字', trigger: 'blur'}
        ],
        platformPhone: [
          // {required: true, message: '请输入手机号码', trigger: 'blur'},
          {pattern: rule.char, message: '手机号格式错误，请检查', trigger: 'blur'}
        ],
        // userRemark: [
        //   { required: true, message: '请输入用户信息备注', trigger: 'blur' }
        // ],
        acceptanceMethod: [
          { required: true, message: '请选择受理方式', trigger: 'change' }
        ],
        // equipmentClassInfo: [
        //   { required: true, message: '请输入设备信息/课堂信息', trigger: 'blur' }
        // ],
        problemOneType: [
          { required: true, message: '请选择问题一级分类', trigger: 'change' },
          {
            validator: (r, val, callback) => {
              if (!this.talkForm.problemTwoType) {
                callback(new Error('请选择问题二级分类'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        problemTwoType: [
          { required: true, message: '请选择问题二级分类', trigger: 'change' }
        ],
        problemDescription: [
          { required: true, message: '请输入问题描述', trigger: 'change' }
        ]
      },
      typeOption: [],
      statusOption: [],
      userTypeOption: [],
      methodOption: [],
      oneTypeOption: [],
      twoTypeOption: [],
      terminalTypeOption: []
    }
  },
  methods: {
    async platformTypeChange (val) {
      // this.userTypeOption = await this.getUserTypeByPlatformType(val)
      // this.talkForm.platformUserType = ''
    },
    // 实时获取富文本的值
    getQuillContent (value) {
      this.talkForm.problemDescription = value
    },
    submitForm () {
      this.$refs.talkForm.validate(async (valid) => {
        if (valid) {
          let params = {
            id: this.id,
            platformType: this.talkForm.platformType,
            platformUserType: this.talkForm.platformUserType,
            platformPhone: this.talkForm.platformPhone,
            groupName: this.talkForm.groupName,
            handerStatus: this.talkForm.handerStatus,
            problemProgress: this.talkForm.problemProgress,
            acceptanceMethod: this.talkForm.acceptanceMethod,
            problemOneType: this.talkForm.problemOneType,
            problemTwoType: this.talkForm.problemTwoType,
            imUserId: this.talkForm.imUserId,
            problemDescription: this.talkForm.problemDescription,
            equipmentClassInfo: this.talkForm.equipmentClassInfo,
            platformTerminalType: this.talkForm.platformTerminalType,
            userRemark: this.talkForm.userRemark
          }
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          try {
            const {data} = this.id ? await editCustomerWorkOrder(params) : await addCustomerWorkOrder(params)
            if (data.resultCode === 0) {
              this.$store.commit('delTab', this.$route)
              this.$message.success(`${this.id ? '编辑' : '新增'}成功`)
              this.$router.push({name: 'Order'})
            } else {
              this.$message.error(data.resultMessage)
            }
          } catch (error) {
          } finally {
            loading.close()
          }
        } else {
          this.scrollToFormError()
          return false
        }
      })
    },
    OneTypeChange () {
      let selectedInfo = ''
      selectedInfo = this.oneTypeOption.find((item) => {
        return item.code === this.talkForm.problemOneType
      })
      let data = {
        typeCode: 'im_customer_problem_two_type',
        pid: selectedInfo.id
      }
      queryBusinessTypeList(data).then(info => {
        if (info.data.resultCode === 0) {
          this.talkForm.problemTwoType = ''
          this.twoTypeOption = info.data.resultData
        } else {
          this.$message.error(info.data.resultMessage)
        }
      })
    },
    // async getUserTypeByPlatformType (platformType) {
    //   let selectedInfo = ''
    //   selectedInfo = this.typeOption.find((item) => {
    //     return item.code === platformType
    //   })
    //   let params = {
    //     typeCode: 'im_customer_platform_user_type',
    //     pid: selectedInfo.id
    //   }
    //   const {data} = await queryBusinessTypeList(params)
    //   if (data.resultCode === 0) {
    //     return data.resultData
    //   }
    // },
    async queryDropdownList () {
      const {data} = await queryManyTypeList()
      if (data.resultCode === 0) {
        this.typeOption = data.resultData.imCustomerPlatform
        this.methodOption = data.resultData.imCustomerAcceptanceMethod
        this.oneTypeOption = data.resultData.imCustomerProblemOneType
        this.statusOption = data.resultData.imCustomerHanderStatus
        this.terminalTypeOption = data.resultData.imCustomerplatformTerminalType
        this.userTypeOption = data.resultData.imCustomerPlatformUserType || []
        this.$forceUpdate()
      }
    }
  },
  async mounted () {
    if (this.id) {
      let data = {
        workOrderId: this.id
      }
      queryCustomerWorkOrderDetail(data).then(async info => {
        let data = info.data.resultData
        if (info.data.resultCode === 0) {
          this.talkForm = data
          await this.queryDropdownList()
          // this.userTypeOption = await this.getUserTypeByPlatformType(this.talkForm.platformType)
          let selectedInfo = ''
          selectedInfo = this.oneTypeOption.find((item) => {
            return item.code === data.problemOneType
          })
          let data1 = {
            typeCode: 'im_customer_problem_two_type',
            pid: selectedInfo.id
          }
          queryBusinessTypeList(data1).then(res => {
            if (res.data.resultCode === 0) {
              this.twoTypeOption = res.data.resultData
            } else {
              this.$message.error(res.data.resultMessage)
            }
          })
          let selectedInfo2 = ''
          selectedInfo2 = this.statusOption.find((item) => {
            return item.name === data.handerStatus
          })
          this.talkForm.handerStatus = selectedInfo2.code
          // setTimeout(() => {
          //   this.editor = window.UM.getEditor('editor', this.config)
          //   this.editor.setContent(data.problemDescription)
          // }, 500)
        } else {
          this.$message.error(info.data.resultMessage)
        }
      })
    } else {
      this.queryDropdownList()
    }
  }
}
</script>
<style lang="less" scoped>

/deep/.ql-container{
  min-height: 250px;
  max-height: 500px;
  overflow-y: auto;
}
/deep/.el-form-item__label-wrap{
  margin-left: 0px!important;
}
.talkForm {
  .el-select, .el-date-editor, .el-input{
    width: 300px;
  }
  .timeData{
    .el-select{
      width: 80px;
    }
    .el-date-editor{
      width: 120px;
    }
    .week-time{
      width: 140px;
    }
  }
  .timeData + .timeData {
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Order/AddTalk.vue